var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-2 col-md-3"}),_c('div',{staticClass:"col-xl-10 col-lg-8 col-md-6"},[_c('system-status-form')],1),_c('div',{staticClass:"col-xl-1 col-lg-2 col-md-3"})])}
var staticRenderFns = []

export { render, staticRenderFns }